// istanbul ignore file
import { CurrentStepProps } from '../../getSideMenuItems';
import { useProductAttributesQuery } from '~/api/productAttributes';
import { StrapiProductAttribute } from '~/shared-types';
import { Select } from '~/components/Backroom/Select';
import { useEffect } from 'react';
import { useWithFetchAll } from '~/api/useWithFetchAll';
import extractMainOrSubCategoriIdFromSelectValue, {
  CategoryType,
} from '~/helpers/extractMainOrSubCategoryIdFromSelectValue';

export const ProductAttributesSelect = ({ form }: CurrentStepProps) => {
  const { control, watch } = form;
  const subCategory = watch('subCategory');

  const subCategoryId = subCategory?.value
    ? extractMainOrSubCategoriIdFromSelectValue(
        subCategory.value as string,
        CategoryType.SUB
      )
    : null;

  const { data, fetchAllPages, isFetching } = useWithFetchAll(
    useProductAttributesQuery(
      subCategoryId
        ? { filters: { subCategories: { id: { $eq: subCategoryId } } } }
        : { enabled: false }
    )
  );

  useEffect(() => {
    if (subCategoryId) fetchAllPages();
  }, [subCategoryId]);

  const attributes = (
    data?.pages?.flatMap((page) => page?.data).filter(Boolean) || []
  ) as StrapiProductAttribute[];

  if (!subCategoryId) return null;
  if (attributes.length === 0 && !isFetching) return (
    <div className="mb-12">
      <h2 className="text-2xl mb-2.5">Produktfiltre</h2>
      <p className="text-secondary-500 text-sm">
        Der er ingen produktfiltre tilknyttet denne kategori endnu.
      </p>
    </div>
  );

  return (
    <div className="mb-12">
      <h2 className="text-2xl mb-2.5">Produktfiltre</h2>
      <p className="text-secondary-800 mb-6">
        Vælg herunder hvis der skal tilføjes filtre til dit produkt, fx størrelse.
      </p>
      <div className="flex flex-col gap-6">
        {attributes.map((attribute) => {
          const values = (attribute.attributes.values || []) as string[];
          const options = values.map((v) => ({ label: v, value: v }));
          return (
            <Select
              key={attribute.id}
              control={control}
              id={'attributeValues.' + attribute.id}
              name={'attributeValues.' + attribute.id}
              label={attribute.attributes.name + ':'}
              options={options}
              isMulti
              isLoading={isFetching}
              noOptionsMessage={() => 'Ingen værdier tilgængelige'}
              placeholder={'Vælg ' + attribute.attributes.name.toLowerCase() + '...'}
            />
          );
        })}
      </div>
    </div>
  );
};
